// extracted by mini-css-extract-plugin
export default {"fields":"add-payout-account-confirmation_fields__llKIY","field":"add-payout-account-confirmation_field__2QI3M","label":"add-payout-account-confirmation_label__NM6MZ"};